/**
 * Given an array of grants, returns the same grants grouped by strategy and alpha sorted.
 * i.e:
 *
 * Strategy Name A
 * -- Matching strategies sorted a-z
 * Strategy Name B
 * -- Matching strategies sorted a-z
 *
 * @param {array} grants grants matching the users selection
 * @param {object} strategies current strategy state
 * @param {integer} sortDir direction to sort. ACS (1) or  DESC (-1)
 */
export default function groupGrantsByStrategy(grants, strategies, sortDir) {
  const stratMap = new Map();

  // Populate the map with strategies.
  Object.keys(strategies).forEach((str) => {
    const val = strategies[str].slug;
    stratMap.set(val, []);
  });

  // Alpha sort grants as they will always be A-Z.
  const sortedGrants = grants.sort((grantA, grantB) => (
    (grantA.name.localeCompare(grantB.name)) * 1
  ));

  // Add the grants to the map under their strategy Map key.
  sortedGrants.forEach((grant) => {
    const strategy = strategies[grant.strategies[0]];
    stratMap.get(strategy.slug).push(grant);
  });

  // Sort the map to be ASC or DESC by strategy.
  const sortedStrategies = 1 === sortDir
    ? [...stratMap.entries()].sort()
    : [...stratMap.entries()].sort().reverse();

  // Map strategy groups into a single multi demesion array.
  const grouped = sortedStrategies.map((grant) => grant[1]);

  // Flatten nested arays and return.
  return grouped.flat();
}
